export enum PERIOD {
  THIS_MONTH = "thisMonth",
  LAST_MONTH = "lastMonth",
  ALL_TIME = "allTime",
}
